import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { PUBLICATIONS } from "@/data/content";

const TYPE_STYLE = {
  Makale: "bg-royal/15 text-royal border-royal/30",
  Kongre: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
  Tez: "bg-purple-500/15 text-purple-400 border-purple-500/30",
};

export const Publications = () => {
  return (
    <section id="yayinlar" className="relative bg-ink py-28 md:py-40 px-6 md:px-10">
      <div className="mx-auto max-w-[1400px]">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 md:mb-24">
          <div>
            <Reveal>
              <p className="text-xs font-semibold tracking-[0.3em] uppercase text-gold mb-8">Yayınlarım</p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-sand max-w-2xl">
                Akademik yayınlar ve çalışmalar.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={2}>
            <p className="text-sm font-light text-mist max-w-xs">
              Deprem mühendisliği ve inşaat süreçleri üzerine makale, kongre ve tez çalışmaları.
            </p>
          </Reveal>
        </div>

        <div className="border-t border-hairline">
          {PUBLICATIONS.map((p, i) => (
            <Reveal key={p.title} delay={i} className="group block border-b border-hairline">
              <div data-testid={`publication-${i}`} className="grid grid-cols-12 items-start gap-4 py-7 md:py-9">
                <div className="col-span-3 md:col-span-2 flex flex-col gap-2">
                  <span className="font-semibold text-lg md:text-xl text-gold/90">{p.year}</span>
                  <span className={`w-fit rounded-full border px-3 py-1 text-[10px] tracking-[0.15em] uppercase ${TYPE_STYLE[p.type] || "bg-white/5 text-mist border-hairline"}`}>
                    {p.type}
                  </span>
                </div>
                <div className="col-span-9 md:col-span-9">
                  <h3 className="font-semibold tracking-tight text-lg md:text-2xl text-sand leading-snug transition-transform duration-500 group-hover:translate-x-1">
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm text-mist">{p.venue}</p>
                  {p.doi && (
                    <a
                      href={`https://doi.org/${p.doi}`}
                      target="_blank"
                      rel="noreferrer"
                      className="mt-1 inline-block text-xs text-gold/80 hover:text-gold transition-colors"
                    >
                      DOI: {p.doi}
                    </a>
                  )}
                </div>
                <span className="hidden md:flex md:col-span-1 justify-end text-mist group-hover:text-gold transition-colors duration-300">
                  <ArrowUpRight size={20} className="transition-transform duration-500 group-hover:rotate-45" />
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
